import { render, staticRenderFns } from "./LeadPer.vue?vue&type=template&id=181fe865"
import script from "./LeadPer.vue?vue&type=script&lang=js"
export * from "./LeadPer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports